export const OPPORTUNITY_CONTACT_ROLES_REQUEST_STARTED =
  'OPPORTUNITY_CONTACT_ROLES_REQUEST_STARTED';
export const OPPORTUNITY_CONTACT_ROLES_REQUEST_SUCCESS =
  'OPPORTUNITY_CONTACT_ROLES_REQUEST_SUCCESS';
